/**
 * Lazy lookup of a short city/state label for a ZCTA, from bundled GeoNames-derived data.
 * @see scripts/build-zcta-primary-place.mjs
 */

let tablePromise = /** @type {Promise<Record<string, { city: string, state: string }>>|null} */ (null);

function normalizeZcta5(z) {
  const d = String(z ?? "").replace(/\D/g, "");
  if (!d) return null;
  return d.slice(0, 5).padStart(5, "0");
}

export async function loadZctaPrimaryPlaceTable() {
  if (!tablePromise) {
    tablePromise = import("../../components/dashboard/auction/data/zctaPrimaryPlace.json").then(
      (m) => m.default || {}
    );
  }
  return tablePromise;
}

/**
 * @param {string} zcta5
 * @returns {Promise<{ city: string, state: string } | null>}
 */
export async function getZctaPrimaryPlace(zcta5) {
  const z = normalizeZcta5(zcta5);
  if (!z || z === "00000") return null;
  const t = await loadZctaPrimaryPlaceTable();
  return t[z] || null;
}
